export const colors = {
  primary: "#111",
  secondary: "#333",
  ternary: "#25c2ab",
  green5: "#1ccab0",
  secondHighlight: "#FFB866",
  logo: "#7a85ff",
  logo1: "#fff",
  logo2: "#7e90fb",
  highlight: "#7a85ff",
  highlight2: "#ccc",
  border: "#d3d7dd",
  neutral: "#aaaeb3",
  grey1: "#f2f5f9",
  grey2: "#eaeff5",
  grey3: "#dce1e8",
  grey4: "#d3d7dd",
  grey5: "#aaaeb3",
  grey6: "#8d939a",
  grey7: "#71727D",
  text: "#65656f",
  header: "#003",
  link: "#003",
  link2: "#003",
  link3: "#003",
  bleu11: "#363670",
  bleu10: "#474793",
  bleu9: "#5354ad",
  bleu8: "#003",
  bleu7: "#7a85ff",
  bleu6: "#333",
  bleu5: "#112",
  bleu4: "#dadefe",
  verified: "darkgreen",
  notverified: "#aaaeb3",
  menuActive: "#fff",
  permissionBg: "#f5f8fc",
  permissionBg2: "#c2cbff",
  // FIXME: Link to ternary instead of copying somehow
  linkHover: "#27cfb7",
  formSelectorBg: "#f5f8fc",
  fieldIcon: "#8e8f9d",
  formSelectorBorder: "#d3d7dd",
  formFieldBg: "#fefefe",
  // FIXME: Link to border & header respectively
  banner: "#222",
  bannerHover: "#7e90fb",
  bannerTitle: "#fff",
  bannerValue: "#ccc",
  bannerSubtitle: "#c2cbff",
  panelBackground: "#fff",
  panelGrayBackground: "#4A4A5E",
  panelBackgroundDisabled: "#f8f9fa",

  pillTitleText: "#616082",
  tableEvenRowBackground: "#f8f9fa",
  tableOddRowBackground: "#fff",

  trendDown: "#ec1c24",
  trendUp: "#7bda49",
  transactionProgress: "#484599",
  traceAccountText: "#fff",
  traceAccountTokenBackground: "#7a85ff",
  traceAccountSystemBackground: "#072242",
  traceAccountGenericBackground: "#8d939a",
  traceActionGenericText: "#65656f",
  traceActionReceiveBackground: "#90ded8",
  traceActionSendBackground: "#ffc88a",
  traceActionGenericBackground: "#eaeff5",
  traceDataHoverBackground: "#EAEEF2",
  traceMemoBackground: "#d3d7dd",
  traceMemoText: "#58596c",

  traceRawButtonBackground: "#EAEEF2",
  traceRawButtonText: "#5F6070",

  toolTipDark: "#343442",
  toolTipLightBg: "#F5F8FC",
  toolTipLightBorder: "#71727D",

  stakeCPU: "#7a85ff",
  stakeREX: "#e50fb6",
  stakeREXFunds: "#f976db",
  delegateCPU: "#686EDE",
  stakeNetwork: "#AE62D4",
  delegateNetwork: "#9D47C7",
  barDataValue: "#4f4fa6",
  barBackground: "#dce1e8",
  barVote: "#4f4fa6",
  barVoteBg: "#dce1e8",

  accountVoteBtn: "#EAEEF2",
  accountVoteBtnOver: "#dee1e4",
  accountVoteBtnOverLink: "#5451b3",
  topBarBackground: "#363670",

  searchBg: "#4f4fa6",
  searchBorder: "#6565d1",
  searchPlaceholder: "#7a85ff",

  statusBadgeBan: "#EE4036",
  statusBadgeBanBg: "#FDE4E3",
  statusBadgeClock: "#FF971F",
  statusBadgeClockBg: "#FFEDD7",
  statusBadgeCheck: "#24C1AA",
  statusBadgeCheckBg: "#F2F5F9",

  testnet: "#f05a28",

  editAdd: "#25c2ab",
  editRemove: "#EE4036"
}
